import { render, staticRenderFns } from "./WeChatLoginPopup.vue?vue&type=template&id=0f79168d&scoped=true"
import script from "./WeChatLoginPopup.vue?vue&type=script&lang=js"
export * from "./WeChatLoginPopup.vue?vue&type=script&lang=js"
import style0 from "./WeChatLoginPopup.vue?vue&type=style&index=0&id=0f79168d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f79168d",
  null
  
)

export default component.exports